//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import autocompleteCommon from '../../common/functions/autocomplete';
import common from './common';
import { getClosestVueParent } from '../../common/functions/helpers';
import { skipLoading } from '../../common/functions/loading';

export default {
  mixins: [common, autocompleteCommon],
  props: {
    extensao: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Array,
      default: null,
    },
    identifier: {
      type: String,
      default: 'id',
    },
    menuStyle: {
      type: String,
      default: 'width:330px; max-height:400px',
    },
    direction: {
      type: String,
      default: 'bottom right',
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      query: '',
      selected: null,
      timeout: 0,
      parentContainer: null,
      searchButton: null,
      lastPrintValue: null,
      verMais: false,
      limit: 6,
      numeroPagina: 0,
    };
  },
  computed: {
    listIsEmpty() {
      return this.list.length === 0;
    },
    inputIdComputado() {
      this.inputId = `md-auto-complete-input-${Date.now()}`;
      return this.inputId;
    },
  },
  watch: {
    list(value) {
      this.items = Object.assign([], value);
    },
    query(value) {
      this.$refs.input.value = value;
      this.setParentUpdateValue(value);
      if (value === '') {
        this.emptyAction();
      }
    },
    value(value) {
      this.query = value;
      this.setParentUpdateValue(value);
    },
  },
  methods: {
    blurInput(e) {
      if (this.lastPrintValue !== null) {
        const el = document.getElementById(this.inputId);
        if (el.value === '' || this.lastPrintValue !== el.value) {
          this.$emit('selected', {}, '');
        }
      }
      if (this.onBlur) {
        this.onBlur(e);
      }
    },
    debounceUpdate() {
      this.onInput();

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }

      this.timeout = window.setTimeout(() => {
        if (!this.listIsEmpty) {
          this.renderFilteredList();
          return;
        }
        this.update();
      }, this.debounce);
    },
    hit(item) {
      const value = this.printAttribute ? item[this.printAttribute] : this.printFunction(item);
      this.query = value;
      this.$refs.input.value = value;
      this.selected = item;
      this.lastPrintValue = value;
      this.onInput();
      this.$emit('selected', this.selected, this.$refs.input.value);
      this.numeroPagina = 0;
      this.verMais = false;
    },
    makeFetchRequestAllRegister() {
      this.makeFetchRequest({});
    },
    makeFetchRequest(queryObject) {
      this.numeroPagina = this.numeroPagina + 1;
      queryObject.tamanhoPagina = this.limit;
      queryObject.numeroPagina = this.numeroPagina;
      if (this.disabled) {
        return null;
      }
      this.loading = true;
      this.toggleMenu();
      skipLoading();
      return this.fetch(queryObject)
        .then((response) => {
          let data = response || response.data || response.body;
          const totalPagina = data.quantidadeRegistrosPagina || data.data.quantidadeRegistrosPagina;
          data = this.prepareResponseData ?
            this.prepareResponseData(data) :
            data;
          this.items = this.limit ?
            data.slice(0, this.limit) :
            data;
          if (this.items.length < this.limit) {
            this.verMais = false;
            this.numeroPagina = 0;
          } else this.verMais = !(totalPagina && totalPagina <= (this.limit * this.numeroPagina));

          if (this.chips) {
            const found = [];
            this.items.forEach((items, index) => {
              this.chips.forEach((chip) => {
                if (items[this.identifier] === chip[this.identifier]) {
                  found.push(index);
                }
              });
            });
            for (let i = found.length - 1; i >= 0; i -= 1) {
              this.items.splice(found[i], 1);
            }
          }
          this.loading = false;
        });
    },
    onFocus() {
      if (this.parentContainer) {
        this.parentContainer.isFocused = true;
      }
      this.$refs.input.focus();
    },
    onInput() {
      this.updateValues();
      this.$emit('change', this.$refs.input.value);
      this.$emit('input', this.$refs.input.value);
    },
    addExtension() {
      this.$emit('addExtension');
    },
    emptyAction() {
      this.$emit('empty');
    },
    renderFilteredList() {
      if (this.filterList) {
        this.items = this.filterList(Object.assign([], this.list), this.query);
      }
      this.toggleMenu();
    },
    reset() {
      this.items = [];
      this.query = '';
      this.loading = false;
      this.numeroPagina = 0;
      this.verMais = false;
    },
    setParentValue(value) {
      const val = value || this.$refs.input.value;
      if (this.parentContainer) {
        this.parentContainer.setValue(val);
      }
    },
    setParentDisabled() {
      if (this.parentContainer) {
        this.parentContainer.isDisabled = this.disabled;
      }
    },
    setParentRequired() {
      if (this.parentContainer) {
        this.parentContainer.isRequired = this.required;
      }
    },
    setParentPlaceholder() {
      if (this.parentContainer) {
        this.parentContainer.hasPlaceholder = !!this.placeholder;
      }
    },
    setParentUpdateValue(value) {
      this.setParentValue(value);
      this.updateValues(value);
    },
    setSearchButton() {
      this.searchButton = this.parentContainer.$el.querySelector('[md-autocomplete-search]');

      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonRequest);
      }
    },
    searchButtonRequest() {
      this.numeroPagina = 0;
      const queryObject = { [this.queryParam]: this.query };
      this.makeFetchRequest(queryObject);
    },
    update() {
      if (!this.query && !this.list.length) {
        return this.reset();
      }

      if (this.minChars && this.query.length < this.minChars) {
        return this;
      }

      this.loading = true;
      this.numeroPagina = 0;
      const queryObject = { [this.queryParam]: this.query };
      return this.makeFetchRequest(queryObject);
    },
    updateVerMais() {
      this.loading = true;

      const queryObject = { [this.queryParam]: this.query };
      return this.makeFetchRequest(queryObject);
    },
    toggleMenu() {
      this.$refs.menu.toggle();
    },
    updateValues(value) {
      const newValue = value || this.$refs.input.value || this.value;

      this.setParentValue(newValue);
      this.parentContainer.inputLength = newValue ? newValue.length : 0;
    },
    verMaisRegistros() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }

      this.timeout = window.setTimeout(() => {
        if (!this.listIsEmpty) {
          this.renderFilteredList();
          return;
        }
        this.updateVerMais();
      }, this.debounce);
    },
  },
  beforeDestroy() {
    if (this.searchButton !== undefined) {
      this.searchButton.removeEventListener('click', this.makeFetchRequest);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.parentContainer = getClosestVueParent(this.$parent, 'md-input-container');

      if (!this.listIsEmpty) {
        this.items = Object.assign([], this.list);
      }

      this.query = this.value;

      this.verifyProps();
      this.setSearchButton();

      this.setParentDisabled();
      this.setParentRequired();
      this.setParentPlaceholder();
      this.handleMaxLength();
      this.updateValues();
    });
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/autocomplete/mdAutocomplete.vue?vue&type=script&lang=js&